import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'

import { PermissionChecker } from '#/components/templates/permission-checker.tsx'
import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'
import { ConsumerStatusPageSkeleton } from '#/modules/platform/back-office/consumer-status-page/consumer-status-page-skeleton.tsx'
import { ConsumerStatusPage } from '#/modules/platform/back-office/consumer-status-page/consumer-status-page.tsx'

export const Route = createFileRoute('/bo/admin/consumer-status')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PharaohNextScope surface="bo">
        <Suspense fallback={<ConsumerStatusPageSkeleton />}>
          <ConsumerStatusPage />
        </Suspense>
      </PharaohNextScope>
    </PermissionChecker>
  ),
})
